import React from "react";
import Image from "next/image";

const AmericanDream = () => {
  return (
    <div className="flex flex-col gap-3 w-full bg-[#061A2F] bg-no-repeat bg-contain bg-bottom p-5 md:pb-14">
      <div className="text-center">
        <h2 className="font-bold 2xl:text-[50px] relative inline-block  md:text-[36px] md:leading-[42px] leading-[23px] text-[20px] md:text-black text-white text-center md:mb-1 mt-6">
          <Image
            src="/healthcare/str.png"
            alt="healthcare icon"
            className="w-[18px] absolute top-9 -right-24 scale-x-[-1]"
            width={12}
            height={11}
          />
          <span className="bg-[url(/line.png)] bg-bottom bg-no-repeat md:mt-1 md:pb-[5px] pb-[5px] leading-[1.1] inline-block text-white">
            Miles US Pathway <br></br>{" "}
            <span className="text-[16px] 2xl:text-[40px] md:text-[26px] border-[#FFA548] leading-[1.1] border-b-[4px] md:pb-[5px] pb-[5px] inline-block text-white">
              Making the American Dream a Reality
            </span>
          </span>
        </h2>
      </div>

      <div className="flex flex-col gap-20 mt-16">
        <div className="grid grid-cols-2 w-[70%] mx-auto">
          <div className="flex justify-end items-start">
            <Image
              priority
              src="/healthcare/nurse.png"
              alt="STEM master's for Indian nurses in the US"
              className="mr-20"
              width={380}
              height={339}
            />
          </div>

          <div className="flex flex-col gap-3">
            <h3 className="text-white mt-16 md:font-bold 2xl:text-[36px] md:text-[26px]">
              For Indian / International{" "}
              <span className="text-[#55B3AC]">Nurses</span>
            </h3>

            <ul className="list-disc ml-5 text-white 2xl:text-[24px] md:text-[16px] space-y-3">
              <li>
                Pursue a STEM-designated master’s in <br /> healthcare from top
                US universities
              </li>
              <li>
                Receive a conditional offer letter (LOI) even
                <br /> before completing your university application
              </li>
              <li>
                Complete your degree and work in the US for
                <br /> up to 3 years on OPT on an F-1 visa
              </li>
              <li>
                Launch your nursing career in the US with a<br /> salary of INR
                ~40 lakhs p.a. ($50k)
              </li>
            </ul>

            <div className="mt-8 md:block hidden relative ">
              <div className="grp_btn flex md:justify-start items-center ">
                <Image
                  priority
                  src="/arrow2.png"
                  alt="arrow image"
                  className="new_arrow mr-1"
                  width={45}
                  height={45}
                  quality={100}
                />
                <a
                  href="/us-jobs-for-nurses"
                  className="new_btn 2xl:text-[20px] md:text-[13px] md:font-semibold  inline-block !px-10"
                >
                  Know More
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* bottom */}
        <div className="grid grid-cols-2 w-[55%] mx-auto">
          <div className="flex flex-col gap-3">
            <h3 className="text-white md:font-bold 2xl:text-[36px] md:text-[26px] mt-12">
              For Aspiring <span className="text-[#55B3AC]">Doctors</span>
            </h3>

            <ul className="list-disc ml-5 2xl:text-[24px] md:text-[16px] text-white space-y-3">
              <li>
                Earn your MD and license to practice medicine in
                <br /> the US{" "}
              </li>
              <li>
                Study alongside US students at leading medical
                <br /> schools
              </li>
              <li>
                NEET UG rank not mandatory to begin your US
                <br /> medical journey
              </li>
              <li>
                Begin your medical career and earn a starting
                <br /> salary of INR ~2 crores p.a. ($230K){" "}
              </li>
            </ul>
            <div className="mt-8 md:block hidden relative">
              <div className="grp_btn flex md:justify-start items-center">
                <Image
                  priority
                  src="/arrow2.png"
                  alt="arrow image"
                  className=" "
                  width={45}
                  height={45}
                  quality={100}
                />
                <a
                  href="/mbbs"
                  className="new_btn text-center 2xl:text-[20px] md:text-[13px] md:font-semibold inline-block !px-10"
                >
                  Know More
                </a>
              </div>
            </div>
          </div>

          <div className="flex justify-start items-start">
            <Image
              priority
              src="/healthcare/doc.png"
              alt="US MD program for aspiring doctors in India"
              className="ml-16"
              width={380}
              height={339}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AmericanDream;
